export const CLIENT_DEFAULT = 'default';
export const CLIENT_SIMPLE = 'simple';
